import axios from "axios";
import NetworkUtils from "@/NetworkUtils";
import store from "../../store";
import StoreOnSalesConfigConstance from "../constants/StoreOnSalesConfigConstance";
import AdsConfigConstance from "../constants/UGSAdsConfigData";
const authorize = `Bearer ${store.getters.getToken}`;
const config = {
    headers: { Authorization: authorize }
};

export default {
    loadDefaultData(){
        return StoreOnSalesConfigConstance;
    },

    loadData: async function () {
        let data = await axios.get(NetworkUtils.HOST + "/store-on-sales-config/load", config);
        let configRQ = {};
        let adsConfigRQ = {};
        if (data.data.length > 0) {
            configRQ = data.data[0].config;
            if(data.data[0].adsConfig){
                adsConfigRQ = data.data[0].adsConfig;
            } else {
                adsConfigRQ = AdsConfigConstance;
            }
            
        } else {
            configRQ = StoreOnSalesConfigConstance;
            adsConfigRQ = AdsConfigConstance;
        }
        // console.log('load store on sales config', configRQ);
        // console.log('load adsConfig', adsConfigRQ);
        return {saleConfig: configRQ, adsConfig: adsConfigRQ};
    },
}